export default {
  methods: {
    nextPage(page) {
      let nextPage = page;
      nextPage = page + 1;

      return nextPage;
    },
    prevPage(page) {
      let prevPage = page;
      if (page > 1) {
        // console.log("page>", page);
        prevPage = page - 1;
      }
      return prevPage;
    }
  }
};
